import React, { useState } from 'react';
import { useI18n } from '../../../shared/i18n/I18nContext';
import { useTheme } from '../../../shared/theme/ThemeContext';

const ForgotPasswordPage = () => {
  const { t } = useI18n();
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email) {
      return;
    }
    setMessage(t('resetEmailSent'));
  };

  return (
    <div className="auth-page" style={{ background: theme.surface, color: theme.text }}>
      <h1>{t('forgot_password')}</h1>
      <p>{t('provide_mail')}</p>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label>
          {t('email')}
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder={t('emailHint')}
          />
        </label>
        <button type="submit" className="auth-button">{t('send_email')}</button>
      </form>
      {message && <div className="auth-success">{message}</div>}
    </div>
  );
};

export default ForgotPasswordPage;
